import { useForm } from 'react-hook-form'

import Button from 'src/ui/atoms/Button'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'

import useEsdtToken, { IMintEsdtToken } from './useEsdtToken'
import useEvmToken, { IMintEvmToken } from './useEvmToken'
import { IProject } from '../../useProjectApi'

const MintToken = ({ project }: { project: IProject }) => {
  const { isLoading, handleToken, isWalletConnected } =
    project.data.chain === 'multiversx'
      ? useEsdtToken({
          payloadKey: 'esdtMintPayload',
        })
      : useEvmToken()

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })

  const handleMint = async (data: IMintEsdtToken | IMintEvmToken) => {
    await handleToken({
      ...data,
      type: 'mint',
      chain: project.data.chain.toUpperCase(),
      network: project.data.network,
      supply: data.supply,
      smartContractAddress: data.smartContractAddress,
      tokenTicker: project.data.detailedTokenTicker,
    })
  }

  return (
    <form
      className="flex flex-col gap-6"
      onSubmit={handleSubmit((data) => handleMint(data as IMintEsdtToken | IMintEvmToken))}>
      <div className="grid gap-4">
        {project.data.chain !== 'multiversx' && (
          <WrappedInput
            placeholder="Smart contract address"
            label="Smart contract address"
            type="number"
            error={errors.smartContractAddress}
            {...register('smartContractAddress', {
              required: 'Required field',
            })}
          />
        )}
        <WrappedInput
          placeholder="Supply to mint"
          label="Supply to mint"
          type="number"
          error={errors.supply}
          {...register('supply', {
            required: 'Required field',
          })}
        />
      </div>
      <Button
        className="self-end"
        size="M"
        name="Mint"
        disabled={!isValid || !isWalletConnected}
        loading={isLoading}
      />
    </form>
  )
}

export default MintToken
